import { styled } from "styled-components";

export const PageLoaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: inherit;
    width: 100%;
    align-items: center;

    .content {
        width: 380px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 200px;
    }
`;
